module.exports = __webpack_public_path__ + "img/up.5c5530f1.svg";